import { createContextAwareHook } from './useContextAwareHook';
import {
  useGetOtherLandQuery,
  usePublicGetOtherLandQuery,
  useGetOtherLandDefaultsQuery,
  usePublicGetOtherLandDefaultsQuery,
  useUpdateOtherLandMutation
} from '../features/modules/otherLandApiSlice';

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting other land data based on the current route.
 */
export const useContextAwareGetOtherLand = createContextAwareHook(
  useGetOtherLandQuery,
  usePublicGetOtherLandQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting other land defaults based on the current route.
 */
export const useContextAwareGetOtherLandDefaults = createContextAwareHook(
  useGetOtherLandDefaultsQuery,
  usePublicGetOtherLandDefaultsQuery
);

// Export mutation hooks directly
export {
  useUpdateOtherLandMutation
}; 